import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { CreateOneOnOneAssignmentPdfScreenPath } from "./paths.ts";

export function useToCreateOneOnOneAssignmentPdfScreen() {
  const navigate = useNavigate();

  const toCreate = useCallback(() => {
    navigate(CreateOneOnOneAssignmentPdfScreenPath);
  }, [navigate]);

  return { toCreate };
}
